import React from 'react';
import PropTypes from 'prop-types';

import {  formatDateTime } from 'helpers/formatters/date_time_formats';

export default class ItemHeader extends React.Component {
  static propTypes = {
    headline: PropTypes.string,
    image: PropTypes.node,
    name: PropTypes.string,
    time: PropTypes.string
  }

  render() {
    return (
      <div className="card-item-header text-muted task-detail" name={this.props.name}>
        {this.props.headline && <div className="text-uppercase">{this.props.headline}</div>}
        <div className="spacer" />
        {this.props.image}
        {this.props.time &&
          <div className="left-buffer-md d-inline-block align-middle">
            { formatDateTime(this.props.time)}
          </div>
        }
      </div>
    );
  }
}
